import React from 'react';
import ImageLoader from '../images/ImageLoader';
import RewardsProgramFeatureList from './RewardsProgramFeatureList';
import { Link } from 'react-router-dom';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

var RewardsProgram = function RewardsProgram(props) {
  var _LegalCopy$, _LegalCopy$$fields, _LegalCopy$$fields$Le, _LegalCopy$2, _LegalCopy$2$fields;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model;
  var _model$FeatureList = model.FeatureList,
      FeatureList = _model$FeatureList === void 0 ? [] : _model$FeatureList,
      LogoImage = model.LogoImage,
      PromotionImage = model.PromotionImage,
      LegalCopy = model.LegalCopy;
  return /*#__PURE__*/React.createElement("div", {
    className: 'container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'row'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'col-lg-12'
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-rewards-program-module"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-module__header-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-module__new-tag'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-rewards-program-module__new-tag-span'
  }, "New")), /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-module__logo-image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: LogoImage,
    type: "product",
    className: "cb-rewards-program-module__logo-image"
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-module__feature-listing-container'
  }, /*#__PURE__*/React.createElement(RewardsProgramFeatureList, {
    model: {
      FeatureList: FeatureList
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-module__promotion-image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: PromotionImage,
    type: "product",
    className: "cb-rewards-program-module__promotion-image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-module__join-now-container'
  }, /*#__PURE__*/React.createElement(Link, {
    to: '/rewards/sign-up?redirect=/rewards',
    className: 'cb-button-primary cb-rewards-program-module__join-now'
  }, "Join Now")), (LegalCopy === null || LegalCopy === void 0 ? void 0 : LegalCopy.length) && (LegalCopy === null || LegalCopy === void 0 ? void 0 : (_LegalCopy$ = LegalCopy[0]) === null || _LegalCopy$ === void 0 ? void 0 : (_LegalCopy$$fields = _LegalCopy$.fields) === null || _LegalCopy$$fields === void 0 ? void 0 : (_LegalCopy$$fields$Le = _LegalCopy$$fields['Legal Copy']) === null || _LegalCopy$$fields$Le === void 0 ? void 0 : _LegalCopy$$fields$Le.value) && /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-module__legal-copy'
  }, /*#__PURE__*/React.createElement(RichText, {
    field: LegalCopy === null || LegalCopy === void 0 ? void 0 : (_LegalCopy$2 = LegalCopy[0]) === null || _LegalCopy$2 === void 0 ? void 0 : (_LegalCopy$2$fields = _LegalCopy$2.fields) === null || _LegalCopy$2$fields === void 0 ? void 0 : _LegalCopy$2$fields['Legal Copy']
  }))))));
};

export default RewardsProgram;